import { useInfiniteQuery} from "@tanstack/react-query";
const { default: apiClient } = require("lib/api-client");

const fetchStocks = async ({ pageParam = 1, queryKey }) => {
  const [, { limit, sortBy, order, searchTerm,location,stockStatus,includeClientDesign }] = queryKey;
  const response = await apiClient.post("/api/v1/stocks/getStockCategory", {
    page: pageParam,
    limit,
    sortBy,
    order,
    searchTerm,
    location,
    stockStatus,
    includeClientDesign
  });

  if (response.status !== 200) {
    throw new Error("Error fetching stocks");
  }

  return {
    categories: response.data.categories,
    nextPage: response.data.pagination.page + 1,
    totalPages: response.data.pagination.totalPages,
    totalCount: response.data.totalCount,
    totalStyles: response.data.totalStyles,
    cardData: response.data.cardData,
  };
};

export const useStocks = ({ limit = 10, sortBy = "", order = "asc", searchTerm = "" ,location =[], stockStatus="", includeClientDesign = false}) => {
  return useInfiniteQuery({
    queryKey: ["stocks", { limit, sortBy, order, searchTerm, location,stockStatus,includeClientDesign}],
    queryFn: ({ pageParam = 1 }) => fetchStocks({ pageParam, queryKey: ["stocks", { limit, sortBy, order, searchTerm ,location,stockStatus,includeClientDesign}] }),
    getNextPageParam: (lastPage) => {
      if (lastPage.nextPage <= lastPage.totalPages) {
        return lastPage.nextPage;
      }
      return undefined;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus:false,
    retry: 1,
    cacheTime: 5 * 60 * 1000,
  });
};
